module.exports = __webpack_public_path__ + "img/BX.4126b3f9.png";